import React from 'react';
import { Mail, Phone, MapPin, Sparkles, ArrowUp } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'About', href: '#about' },
    { name: 'Research', href: '#research' },
    { name: 'Publications', href: '#publications' },
    { name: 'Projects', href: '#projects' },
    { name: 'Teaching', href: '#teaching' },
    { name: 'Labs', href: '#labs' },
    { name: 'Administrative', href: '#administrative' },
    { name: 'Contact', href: '#contact' },
  ];

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <footer className="bg-gradient-to-br from-slate-900 via-blue-900 to-purple-900 text-white relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-gradient-to-br from-blue-500 to-purple-500 rounded-full filter blur-3xl opacity-10"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-gradient-to-br from-cyan-500 to-pink-500 rounded-full filter blur-3xl opacity-10"></div>
      
      <div className="w-full px-12 py-12">
        <div className="grid md:grid-cols-3 gap-12 mb-8">
          {/* About Section */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <Sparkles size={24} className="text-cyan-400" />
              <h3 className="text-2xl font-bold bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent">
                Dr. Nelson Muthu
              </h3>
            </div>
            <p className="text-slate-300 leading-relaxed mb-4">
              Associate Professor in Mechanical Engineering at IIT Palakkad, specializing in Computational Elasticity, 
              Mechanics of Composites, and Medical Device Innovation.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-bold mb-4 text-cyan-400">Quick Links</h3>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    onClick={(e) => scrollToSection(e, link.href)}
                    className="text-slate-300 hover:text-cyan-400 transition-all duration-300 cursor-pointer inline-block hover:translate-x-2"
                  >
                    → {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-xl font-bold mb-4 text-purple-400">Contact</h3>
            <div className="space-y-3">
              <div className="flex items-start gap-3 group">
                <Mail size={20} className="text-cyan-400 mt-1 group-hover:scale-110 transition-transform" />
                <a href="mailto:nelsonm@iitpkd.ac.in" className="text-slate-300 hover:text-cyan-400 transition-colors">
                  nelsonm@iitpkd.ac.in
                </a>
              </div>
              <div className="flex items-start gap-3 group">
                <Phone size={20} className="text-purple-400 mt-1 group-hover:scale-110 transition-transform" />
                <span className="text-slate-300">0491 209 1464</span>
              </div>
              <div className="flex items-start gap-3 group">
                <MapPin size={20} className="text-pink-400 mt-1 group-hover:scale-110 transition-transform" />
                <span className="text-slate-300">
                  IIT Palakkad, Kerala, India
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-slate-700 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-slate-400">
            © {currentYear} Dr. Nelson Muthu. All rights reserved.
          </p>
          <button
            onClick={scrollToTop}
            className="bg-gradient-to-r from-blue-600 to-cyan-500 hover:from-blue-700 hover:to-cyan-600 text-white px-6 py-3 rounded-full shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300 flex items-center gap-2"
          >
            <ArrowUp size={20} />
            Back to Top
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;